import { z } from "zod";
import { ATTACHMENT_OWNER_TYPES } from "../audit.js";
import { ROLE_KEYS } from "../roles.js";
export const listQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(100).default(50),
    offset: z.coerce.number().int().min(0).max(100000).default(0),
});
export const optionalText = (max) => z
    .union([z.string().trim().max(max), z.literal("")])
    .optional()
    .transform((v) => (v === "" || v === undefined ? undefined : v));
export const optionalEmail = () => z
    .union([
    z.string().trim().toLowerCase().email("Enter a valid email address.").max(254),
    z.literal(""),
])
    .optional()
    .transform((v) => (v === "" || v === undefined ? undefined : v));
export const optionalUuid = () => z
    .union([z.string().uuid(), z.literal("")])
    .optional()
    .transform((v) => (v === "" || v === undefined ? undefined : v));
export const moneyField = z
    .string()
    .trim()
    .regex(/^\d+(\.\d{1,2})?$/, "Amount must be a positive number with at most 2 decimals.");
export const quantityField = z
    .string()
    .trim()
    .regex(/^\d+(\.\d{1,4})?$/, "Quantity must be a positive number with at most 4 decimals.")
    .refine((v) => Number(v) > 0, "Quantity must be greater than zero.");
export const nonNegativeInt = z.number().int().min(0).max(1_000_000);
export const priorityField = z.enum(["low", "medium", "high"]).default("medium");
export const loginSchema = z.object({
    email: z.string().trim().toLowerCase().email("Enter a valid email address.").max(254),
    password: z.string().min(8, "Password must be at least 8 characters.").max(200),
});
const passwordPolicy = z
    .string()
    .min(10, "Password must be at least 10 characters.")
    .max(200)
    .regex(/[a-z]/, "Password must contain a lowercase letter.")
    .regex(/[A-Z]/, "Password must contain an uppercase letter.")
    .regex(/[0-9]/, "Password must contain a digit.");
export const createUserSchema = z.object({
    email: z.string().trim().toLowerCase().email().max(254),
    displayName: z.string().trim().min(1, "Name is required.").max(120),
    role: z.enum(ROLE_KEYS),
    password: passwordPolicy,
});
export const userIdParamSchema = z.object({
    id: z.string().uuid("Invalid user id."),
});
export const attachmentOwnerSchema = z.object({
    ownerType: z.enum(ATTACHMENT_OWNER_TYPES),
    ownerId: z
        .string()
        .regex(/^[A-Za-z0-9_-]{1,64}$/, "Reference must be letters, digits, dash or underscore (max 64)."),
});
export const attachmentIdParamSchema = z.object({
    id: z.string().uuid("Invalid attachment id."),
});
export const listAuditQuerySchema = listQuerySchema.extend({
    action: z.string().trim().min(1).max(60).optional(),
});
//# sourceMappingURL=common.js.map